export default "/images/vendor/flag-icon-css/flags/4x3/mo.svg?ac9b1701934ac68456104bab8ff6c5c8";